import { TitleSection } from "components/styles";
import { Container } from "./styles";
import CloseButton from "components/CloseButton/CloseButton";
import HistoryTable from "../components/HistoryTable/HistoryTable";
import NotificationNoContent from "components/NotificationNoContent/NotificationNoContent";
import CustomDialogAlert from "components/DialogAlert/v2";

const DialogChangeHistory = ({
    dialogShow,
    changeHistory
}) => {
    const isEmptyHistory = !changeHistory || changeHistory.length === 0;
    return (
        <CustomDialogAlert dialog={dialogShow}>
            <CloseButton onClick={() => dialogShow.hide()} />
            <Container className={isEmptyHistory ? "empty" : ""}>
                <TitleSection
                    fontWeight="900"
                    textAlign="center">
                    Historial de cambios
                </TitleSection>
                {!isEmptyHistory
                    ? <HistoryTable changeHistory={changeHistory} />
                    : <NotificationNoContent
                        title="Tu historial está vacío"
                        description="Cuando realices cambios quedarán registrados aquí."
                    />}
            </Container>
        </CustomDialogAlert>
    );
}

export default DialogChangeHistory;